var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHealthcareProviderIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7143 5.85714H13.5714V3.28571C13.5714 2.57857 12.9929 2 12.2857 2H9.71429C9.00714 2 8.42857 2.57857 8.42857 3.28571V5.85714H3.28571C2.57857 5.85714 2 6.43571 2 7.14286V18.7143C2 19.4214 2.57857 20 3.28571 20H18.7143C19.4214 20 20 19.4214 20 18.7143V7.14286C20 6.43571 19.4214 5.85714 18.7143 5.85714ZM9.71429 3.28571H12.2857V8.42857H9.71429V3.28571ZM8.42857 11C9.13571 11 9.71429 11.5786 9.71429 12.2857C9.71429 12.9929 9.13571 13.5714 8.42857 13.5714C7.72143 13.5714 7.14286 12.9929 7.14286 12.2857C7.14286 11.5786 7.72143 11 8.42857 11ZM11 16.1429H5.85714V15.5C5.85714 14.6386 7.56714 14.2143 8.42857 14.2143C9.29 14.2143 11 14.6386 11 15.5V16.1429ZM16.1429 14.8571H12.2857V13.5714H16.1429V14.8571ZM16.1429 12.2857H12.2857V11H16.1429V12.2857Z",
    fill: "#008381"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthcareProviderIcon);
export default __webpack_public_path__ + "static/media/HealthcareProviderIcon.c965249c.svg";
export { ForwardRef as ReactComponent };